import React from 'react'
import { IAVisual } from '../IAVisual/IAVisual'
import './Overview.scss'

import { useState } from 'react'
import { Hotspot, HotspotLegend } from '../IAVisual/components/Hotspot'
import '../IAVisual/IAVisual.scss'

import content from '../content.json'

/**
 *  Responsible for showing the Desktop version of the HeaderBar
 */
 class Overview extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        rightOpen: true,
        bottomOpen: false
      }
    }
  
    toggleSidebar = (event) => {
      let key = `${event.currentTarget.parentNode.id}Open`;
      this.setState({ [key]: !this.state[key] });
      this.setState({
        rightArrow: !this.state.rightArrow
      });
    }

    // function that toggles the navbar
    toggleNavbar = () => {
      // When this is clicked, the parent class's className will include nav-open
      // which will show the navbar
      this.setState({
        bottomOpen: !this.state.bottomOpen
      });
    }
  
    render() {
      let rightOpen = this.state.rightOpen ? 'open' : 'closed';
      let navigation = this.state.bottomOpen ? 'nav-bottom nav-open' : 'nav-bottom';
      let rightArrow = this.state.rightArrow ? 'sidebar-toggle-image-container left' : 'sidebar-toggle-image-container right';
      let boolOpen = true
      let iconColor = 'white'

      if (rightOpen == 'open') {
        iconColor = 'white'
        boolOpen = true
      } else {
        iconColor = 'black'
        boolOpen = false
      }

      return (
        <div id='overview-layout'>
          <div className={this.state.bottomOpen ? 'nav-close' : 'invisible'} onClick={this.toggleNavbar}></div>
          
          <nav className={navigation}>
            <a href="#" class="nav-toggle" onClick={this.toggleNavbar}></a>
            <div className="nav-toggle-image-container" onClick={this.toggleNavbar}></div>
            <div className="nav-grid-4-columns">
              <div className="nav-grid-item">
                <HotspotLegend
                  content={content.ControlPanelSolutions}
                  onSelection={this.onSelection}
                />
                <h2> Control Panel Solutions </h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.IndustrialComputing}
                        onSelection={this.onSelection}
                />
                <h2>Industrial Computing</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.MachineSafety}
                        onSelection={this.onSelection}
                />
                <h2> Machine Safety </h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.MotionControls}
                        onSelection={this.onSelection}
                />
                <h2> Motion Controls</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Networking}
                        onSelection={this.onSelection}
                />
                <h2> Networking</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.OperatorInterface}
                        onSelection={this.onSelection}
                />
                <h2> Operator Interface + HMI</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.PowerMonitoring}
                        onSelection={this.onSelection}
                />
                <h2> Power Monitoring</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Sensors}
                        onSelection={this.onSelection}
                />
                <h2> Sensors</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Cybersecurity}
                        onSelection={this.onSelection}
                />
                <h2> Cybersecurity</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Pneumatics}
                        onSelection={this.onSelection}
                />
                <h2> Pneumatics</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.IIotSolutions}
                        onSelection={this.onSelection}
                />
                <h2> Industrial Internet of Things</h2>
              </div>
              <div className="nav-grid-item">
                <HotspotLegend
                        content={content.Drives}
                        onSelection={this.onSelection}
                />
                <h2> Drives</h2>
              </div>
            </div>
          </nav>



            <div id='overview-main'>
                <div className='overview-header'>
                    <h3 className={`
                        overview-title
                        ${'right-' + rightOpen}
                    `}>
                    </h3>
                </div>
                <div className='overview-main-content'>
                    <IAVisual />
                </div>
            </div>
  
            <div id='right' className={rightOpen} >
              <a href="#" class="sidebar-toggle" onClick={this.toggleSidebar}>
                <h2>Products</h2>
              </a>
                <div className={rightArrow} onClick={this.toggleSidebar}></div>
                <div className='overview-icon' style={{ color: iconColor }}
                     onClick={this.toggleSidebar} >
                     {boolOpen ? (<span className='whiterightarrow'>&#x2715;</span>):(<span className='whiteleftarrow'>&#8592;</span>)}
                </div>
                <div className={`overview-sidebar ${rightOpen}`} >
                    <div className='overview-header'>
                    </div>
                    <div className='overview-sidebar-content'>
                        <h3 style ={{borderBottom: "4px solid white", paddingBottom: "5px"}}>
                            Graybar has Industrial Automation Solutions
                        </h3>
                        
                        <br/>

                        <p>
                        Industrial automation helps you do what you do best, even better. Monitor and manage operations in near-real time, 
                        and turn data into insights to improve productivity, quality and safety long term. From maintaining legacy equipment 
                        to modernization, Graybar has the technical know-how and relationships with industry-leading manufacturers to be your 
                        single source for industrial automation solutions. We’ll work with you to build the right technology roadmap for your 
                        facility.
                        </p>
                    </div>
                </div>
            </div>
  
        </div>
      );
    }
  }
  
  export default Overview;